module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Calisto MT",
      "letter-spacing": "1px",
      "font-size": "18pt",
      "padding-top": "10px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.0625in",
      "height": "2.80208in"
    },
    attrs: {
      "alt": " ",
      "src": "media/file0.jpg"
    }
  })]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Yvonne Webb has led an accomplished professional life as an academic, culinary dietitian, author, nutritionist/physiologist, researcher and consultant to government bodies and industry, and has been a national and international speaker. She has held leadership positions of various relevant bodies.")]), _vm._v(" "), _c('p', [_vm._v("An Honours from Shimane University, Japan, and time spent at Uppsala University, Sweden, have been part of her active life.")]), _vm._v(" "), _c('p', [_vm._v("She is a Slow Food disciple and gourmand and was at one time Leader of Slow Food Brisbane.")]), _vm._v(" "), _c('p', [_vm._v("Concern with the obesity epidemic and the amount of myth, fake news and marketing surrounding this problem has led to this book.")]), _vm._v(" "), _c('p', [_vm._v("Having previously established a very successful weight control clinic, she has decided to reveal her secrets based on established scientific knowledge.")]), _vm._v(" "), _c('p', [_vm._v("Nowadays, Yvonne has retired to the suburbs, cultivates an edible garden and gives talks to community groups.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0